// extracted by mini-css-extract-plugin
export default {"price":"_7-z","onSale":"a8-z","msrpLabelPrice":"b8-z","msrpLabel":"c8-z","originalPrice":"d8-z","percentOff":"e8-z"};